/*** IMPORTS FROM imports-loader ***/
var global = window;

export default function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
